export default __webpack_public_path__ + "static/blob-214f6f04d8acdf02596e9cf17f34939a.png";